import Swiper from 'swiper/bundle';

export function initObjectGallerySliders() {
  const $galleries = jQuery('.object-gallery');

  if ($galleries.length) {
    $galleries.each(function (index, element) {
      new Swiper(element, {
        loop: true,
        navigation: {
          nextEl: jQuery(element).find(".swiper-button-next")[0],
          prevEl: jQuery(element).find(".swiper-button-prev")[0],
        },
      });
    });
  }
}
